import { css } from '@linaria/core';
import { styled } from '@linaria/react';

// eslint-disable-next-line no-restricted-imports
import { MqMobileOnly, MqTablet } from '~theme/media';
import { visualHideScrollbar } from '~theme/snippets';

export const hiddenDesktop = css`
	${MqTablet} {
		display: none !important;
	}
`;

export const hiddenMobile = css`
	${MqMobileOnly} {
		display: none !important;
	}
`;

export const FiltersBarContainer = styled.div`
	display: flex;
	width: 100%;
	min-width: 0;
	max-width: 1170px;
	height: 56px;
	align-items: center;
	margin-right: -56px;
	gap: var(--gap-m);
	overflow-x: scroll;

	${MqTablet} {
		gap: var(--gap-x3);
	}

	${visualHideScrollbar}
`;

export const MobileSearchBarWrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	padding-right: 12px;
	padding-left: 12px;
	margin: 16px 0;
`;

export const Wrapper = styled.div`
	display: flex;
	width: 100%;
	min-width: 0;
	max-width: 1170px;
	height: 56px;
	margin: 16px auto;
`;

export const SFWWrapper = styled(Wrapper)`
	align-items: center;
	justify-content: center;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	padding-left: 8px;
	gap: 10px;

	${MqTablet} {
		padding-left: 0;
	}
`;

export const Separator = styled.div`
	display: none;
	width: 1px;
	height: 28px;
	background-color: rgba(255, 255, 255, 0.2);

	${MqTablet} {
		display: block;
	}
`;
